import { render, staticRenderFns } from "./SearchCatalogProducts.vue?vue&type=template&id=92fc800e&scoped=true&"
import script from "./SearchCatalogProducts.vue?vue&type=script&lang=js&"
export * from "./SearchCatalogProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fc800e",
  null
  
)

export default component.exports